module.exports = __webpack_public_path__ + "static/media/osker.2fdf2fde.mp3";